import urls from "global/constants/UrlConstants";
import { getCallParams, makeCall } from "utils/service";

export async function getReuestData() {
  try {
    const url = `${urls.FETCH_REQUEST_DATA}`;
    const callParams = await getCallParams("GET");
    const response = await makeCall(url, callParams);
    return response;
  } catch (error) {
    throw error;
  }
}
